
import { mapState, mapGetters } from 'vuex'

export default {
  props: ['filters', 'filterLabels', 'sorts', 'facetsValues'],
  computed: {
    ...mapState('session', ['user']),
    ...mapGetters('session', ['activeAccount']),
    localStorageKey () {
      return `df-search:${this.$route.name}:${this.user.id}:${this.activeAccount.type}:${this.activeAccount.id}`
    }
  },
  watch: {
    '$route' () {
      this.readParams()
    },
    facetsValues: {
      handler () {
        this.writeParams()
      },
      deep: true
    }
  },
  mounted () {
    this.readParams()
  },
  methods: {
    readParams () {
      const query = this.$route.query

      // use the last params if this page is opened without parameters
      // if (window.localStorage && Object.keys(this.$route.query).length === 0) query = JSON.parse(window.localStorage.getItem(this.localStorageKey) || '{}')
      if (this.facetsValues) {
        Object.keys(this.facetsValues).forEach(key => {
          this.$set(this.facetsValues, key, query[key] ? query[key].split(',') : [])
        })
      }
      if (this.filterLabels) {
        Object.keys(this.filterLabels).forEach(key => {
          this.$set(this.filters, key, query[key])
        })
      }
      this.$set(this.filters, 'q', query.q)
      this.$set(this.filters, 'shared', query.shared === 'true')
      if (this.sorts) this.$set(this.filters, 'sort', query.sort || 'createdAt:-1')
      this.$emit('apply')
    },
    writeParams () {
      const query = { ...this.$route.query }
      if (this.facetsValues) {
        Object.keys(this.facetsValues).forEach(key => {
          if (this.facetsValues[key] && this.facetsValues[key].length) query[key] = this.facetsValues[key].join(',')
          else delete query[key]
        })
      }
      Object.keys(this.filters).forEach(key => {
        if (![null, undefined, '', true].includes(this.filters[key])) query[key] = '' + this.filters[key]
        else delete query[key]
      })
      if (this.filters.shared) query.shared = 'true'
      else delete query.shared
      if (this.filters.ownerExt) query.ownerExt = this.filters.ownerExt
      else delete query.ownerExt
      if (this.sorts && this.filters.sort) query.sort = this.filters.sort
      else delete query.sort

      if (JSON.stringify(this.$route.query) === JSON.stringify(query)) return
      // if (window.localStorage) window.localStorage.setItem(this.localStorageKey, JSON.stringify(query))
      this.$router.replace({ query })
    }
  }
}
